import React from 'react';
import { useHistory } from 'react-router-dom';
import { Alert, Box, Button, MarkdownLite, Stack, Text, TextField } from '@origin-digital/ods-core';
import { ChangeEvent, useState } from 'react';
import { BackButton } from 'ts/passwordless-login/components/sub-components/back-button/BackButton';
import { CaptchaDisclaimer } from 'ts/login/components/CaptchaDisclaimer';

export const BusinessCustomerLookupForm = ({
  handleSubmit,
  loading,
  alertBoxError,
  setAlertBoxError,
}) => {
  const history = useHistory();

  const [accountNumber, setAccountNumber] = useState('');
  const [accountNumberError, setAccountNumberError] = useState(false);

  const [businessName, setBusinessName] = useState('');
  const [businessNameError, setBusinessNameError] = useState(false);

  const [abn, setABN] = useState('');
  const [abnError, setABNError] = useState(false);

  const onChange = (event: ChangeEvent<HTMLInputElement>, setter: (input: string) => void) =>
    setter(event.target.value);

  const validateForm = () => {
    setAccountNumberError(!accountNumber);
    setBusinessNameError(!businessName);
    setABNError(!abn);
  };

  const onSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    validateForm();
    const hasValidationErrors =
      !accountNumber ||
      !businessName ||
      !abn ||
      accountNumberError ||
      businessNameError ||
      abnError;
    if (!hasValidationErrors) {
      handleSubmit(accountNumber, businessName, abn);
    }
  };

  return (
    <form>
      <Stack>
        {alertBoxError && (
          <Box>
            <Alert tone="critical" onCloseClick={() => setAlertBoxError(undefined)}>
              <Text data-id="alertBoxError">
                <MarkdownLite>{alertBoxError}</MarkdownLite>
              </Text>
            </Alert>
          </Box>
        )}
        <TextField
          id="accountNumber"
          label="Account number"
          name="accountNumber"
          onChange={(event) => onChange(event, setAccountNumber)}
          onBlur={() => setAccountNumberError(!accountNumber)}
          error={accountNumberError}
          maxLength={12}
          type="tel"
          helperText={accountNumberError ? 'Please enter your 12 digit account number' : ''}
        />
        <TextField
          id="businessName"
          label="Company name"
          name="businessName"
          onChange={(event) => onChange(event, setBusinessName)}
          onBlur={() => setBusinessNameError(!businessName)}
          error={businessNameError}
          helperText={
            businessNameError
              ? 'Oops, we need your company name as it appears on your bill.'
              : 'As it appears on your bill.'
          }
        />
        <TextField
          id="abn"
          label="ABN"
          name="abn"
          onChange={(event) => onChange(event, setABN)}
          onBlur={() => setABNError(!abn)}
          error={abnError}
          maxLength={12}
          type="tel"
          helperText={abnError ? 'Oops, we need your ABN (numbers only please).' : ''}
        />
      </Stack>
      <Button type="submit" data-id="look-for-email" onClick={onSubmit} spinner={loading} fullWidth>
        Find my account details
      </Button>
      <BackButton history={history} text="Try a different email or mobile" />
      <CaptchaDisclaimer noPadding />
    </form>
  );
};
